var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("view-page", {
    staticClass: "management background",
    attrs: {
      title: _vm.pageTitle,
      "permission-name": "field_management",
      "edit-button": false,
      "delete-button": false,
      loading: _vm.loading,
      backButton: false
    },
    scopedSlots: _vm._u([
      {
        key: "leftSide",
        fn: function() {
          return _vm._l(_vm.fields, function(field) {
            return _c("view-page-data-field", {
              key: field.label,
              attrs: { icon: field.icon, label: field.label, data: field.data }
            })
          })
        },
        proxy: true
      },
      {
        key: "headerRightSide",
        fn: function() {
          return [
            _c("management-tabs-and-search", {
              attrs: { tabs: _vm.tabs, "open-tab": _vm.openTab },
              on: {
                "update-open-tab": function($event) {
                  _vm.openTab = $event
                }
              }
            })
          ]
        },
        proxy: true
      },
      {
        key: "rightSide",
        fn: function() {
          return [
            _c(
              "v-tabs-items",
              { attrs: { value: _vm.openTab } },
              [
                _c("v-tab-item", { attrs: { value: "description" } }, [
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.activity.description,
                        expression: "activity.description"
                      }
                    ],
                    staticClass: "input-field elevation-1",
                    attrs: { id: "description", readonly: "" },
                    domProps: { value: _vm.activity.description },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.activity,
                          "description",
                          $event.target.value
                        )
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c(
                  "v-tab-item",
                  { attrs: { value: "tasks" } },
                  [
                    _c("TasksTable", {
                      attrs: { activityUUID: _vm.activity.uuid },
                      on: {
                        viewTask: function($event) {
                          return _vm.$emit("viewTask", $event)
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f836bd2a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f836bd2a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Content/Tabs/Activities/ActivityView.vue
// module id = null
// module chunks = 